import { render, staticRenderFns } from "./ChoicesInput.vue?vue&type=template&id=d62ab9b6"
import script from "./ChoicesInput.vue?vue&type=script&lang=js"
export * from "./ChoicesInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports